import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Colors, Spacing } from '@/shared/theme';

// Full-screen boot loader shown while the Statsig client initializes
// (RND-36404). The app has no full-page splash otherwise; this mirrors the
// button spinner's `spin` animation from src/shared/ui.tsx at page scale.
const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: ${Spacing.x6}px;
  background-color: ${Colors.background};
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid ${Colors.backgroundAlt};
  border-top-color: ${Colors.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const FullScreenLoader: React.FC = () => (
  <Container role="status" aria-live="polite" aria-busy="true">
    <Spinner aria-hidden="true" />
  </Container>
);
